<a href="javascript:void(0)" mat-button class="btn-close-session">
  <mat-icon matTooltip="Cerrar sesión" [matTooltipPosition]="'left'" matTooltipClass="tooltip-logout" class="ico-logout"
    (click)="cerrarSesion()">exit_to_app</mat-icon>
</a>